import { createApp } from 'vue'
import App from '@/App.vue'
import store from './store'
import '@/assets/css/styles.css';
import '@/assets/css/theme.css';

const app = createApp(App);

app.use(store);
app.mount('#app');